import { useContext, useEffect, useState } from 'react';

import EnrollButton from '@/app/components/core/EnrollButton';
import { Logos } from '@/app/_components/shared/Logos/Logos';
import { sword } from '@swordhealth/ui-corporate';

import ClientContext from '@/contexts/client.context';

import useBetterMediaQuery from '@/utils/useBetterMediaQuery';
import { products } from '@/utils/products';
import Image from 'next/image';

import { Wrapper, CustomContainer, WrapperInner, Buttons } from './style.js';

export default function Bar({
  refBar,
  portugueseHealthPlan = false,
  logos,
  showSwordLogo,
  topBanner,
  hideEnrollButton = false,
  buttonLabel,
  scrollTop,
}) {
  const { client, openModal, product } = useContext(ClientContext);
  const isMobile = useBetterMediaQuery(`(max-width: ${sword.breakpoints.maxSm})`);
  const [scrollY, setScrollY] = useState(0);
  const [initialOffsetTop, setInitialOffsetTop] = useState(0);

  useEffect(() => {
    const handleScroll = () => {
      setScrollY(window.scrollY);
    };

    window.addEventListener('scroll', handleScroll, { passive: true });
    handleScroll();

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  useEffect(() => {
    if (refBar?.current) {
      setInitialOffsetTop(refBar.current.offsetTop);
    }
  }, []);

  return (
    <Wrapper
      ref={refBar}
      $scrolled={scrollY > initialOffsetTop}
      $notSticky={isMobile}
      $topBanner={topBanner}
    >
      <CustomContainer>
        <WrapperInner $extraPadding={portugueseHealthPlan}>
          {logos ? (
            <Logos
              logos={logos}
              noPadding
              centered={isMobile && logos?.length >= 1 && showSwordLogo}
              customHeight={isMobile ? 40 : 50}
              showSwordLogo={showSwordLogo}
            />
          ) : (
            <Image
              loading="lazy"
              alt={`${product?.name || 'Sword'} logo`}
              src={product?.logo ?? products.PLATFORM.logo}
              height={isMobile ? 40 : 50}
              width={isMobile ? 100 : 116}
            />
          )}

          <Buttons $show={scrollY > initialOffsetTop}>
            {!hideEnrollButton && (
              <EnrollButton
                id="header_button"
                isActive={client.isActive}
                buttonLocation="navigation"
                openModal={() =>
                  openModal({ buttonText: buttonLabel, buttonLocation: 'navigation' })
                }
                client={client}
                buttonLabel={buttonLabel}
                product={client.product}
                redirectToApp={client.redirectToApp}
                scrollTop={scrollTop}
              />
            )}
          </Buttons>
        </WrapperInner>
      </CustomContainer>
    </Wrapper>
  );
}
